import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// PWA Affiliate Tracking: escuta mensagens do Service Worker e persiste o ref
// em sessionStorage (apenas na sessão atual) ANTES do React montar.
// Defesa contra PWA launchers que descartam query params ao abrir o app.
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data && event.data.type === 'AFFILIATE_REF' && event.data.ref) {
      try {
        const ref = event.data.ref;
        sessionStorage.setItem('ref_reseller_id', ref);
        window.__pendingRef = ref;
        console.log('🔗 SW capturou ref de afiliado (sessão):', ref);
      } catch (e) {
        console.error('Erro ao salvar ref do SW:', e);
      }
    }
  });
}

// App salvo na tela inicial: marca o documento para reservar a área segura do
// aparelho (hora, wifi e bateria cobriam os botões do topo do jogo).
if (typeof window !== 'undefined') {
  const instalado = window.matchMedia('(display-mode: standalone)').matches
    || window.matchMedia('(display-mode: fullscreen)').matches
    || window.navigator.standalone === true;
  if (instalado) document.documentElement.classList.add('is-pwa');
}

const root = ReactDOM.createRoot(document.getElementById("root"));root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
